import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const RegisterContainer = styled.div`
 min-height: 100vh;
 background-color: white;
 font-family: 'Noto Sans Thai', sans-serif !important;
 * {
   font-family: 'Noto Sans Thai', sans-serif !important;
 }
`;

const Header = styled.div`
 background: white;
 padding: 16px 24px;
 display: flex;
 align-items: center;
 gap: 12px;
 box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.img`
 width: 32px;
 height: 32px;
 object-fit: contain;
`;

const HeaderTitle = styled.h1`
 font-size: 18px;
 font-weight: bold;
 color: #666;
 margin: 0;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const StepIndicator = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 padding: 24px;
 gap: 16px;
`;

const StepCircle = styled.div`
 width: 40px;
 height: 40px;
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 18px;
 font-weight: 600;
 font-family: 'Noto Sans Thai', sans-serif !important;
 
 ${props => props.active ? `
   background-color: #00BBD3;
   color: white;
 ` : `
   background-color: #e1e5e9;
   color: #999;
 `}
`;

const StepLine = styled.div`
 width: 60px;
 height: 4px;
 background-color: ${props => props.active ? '#00BBD3' : '#e1e5e9'};
 border-radius: 2px;
 transition: background-color 0.3s ease;
`;

const Content = styled.div`
 padding: 24px;
 max-width: 400px;
 margin: 0 auto;
`;

const SectionTitle = styled.h2`
 font-size: 22px;
 font-weight: 600;
 color: #00BBD3;
 margin-bottom: 8px;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const SectionSubtitle = styled.p`
 font-size: 18px;
 color: #00BBD3;
 margin-bottom: 24px;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const InfoGrid = styled.div`
 display: grid;
 gap: 16px;
 margin-bottom: 32px;
`;

const InfoRow = styled.div`
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 12px 0;
`;

const InfoLabel = styled.span`
 font-size: 18px;
 color: #666666;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const InfoValue = styled.span`
 font-size: 18px;
 color: #00BBD3;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const InputSection = styled.div`
 margin-bottom: 32px;
`;

const InputLabel = styled.p`
 font-size: 18px;
 color: #666666;
 margin-bottom: 16px;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const InputRow = styled.div`
 display: flex;
 align-items: center;
 gap: 16px;
 margin-bottom: 24px;
`;

const PressureInput = styled.input`
 width: 120px;
 padding: 18px;
 border: 2px solid #e1e5e9;
 border-radius: 12px;
 font-size: 18px;
 color: #666666;
 background-color: white;
 transition: border-color 0.3s ease;
 font-family: 'Noto Sans Thai', sans-serif !important;
 font-weight: bold;
 text-align: center;

 &:focus {
   outline: none;
   border-color: #00BBD3;
 }
`;

const UnitLabel = styled.span`
 font-size: 18px;
 color: #666;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const CheckButton = styled.button`
 background-color: #00BBD3;
 color: white;
 border: none;
 border-radius: 30px;
 padding: 18px 32px;
 font-size: 18px;
 font-weight: bold;
 cursor: pointer;
 transition: all 0.3s ease;
 font-family: 'Noto Sans Thai', sans-serif !important;
 box-shadow: 0 9px 14px 0 rgba(0, 187, 211, 0.08);

 &:hover {
   background-color: #009bb3;
 }

 &:active {
   background-color: #008aa0;
 }
`;

const ResultSection = styled.div`
 margin-bottom: 32px;
`;

const ResultCard = styled.div`
 background-color: #e6f9ff;
 border: 2px solid #00BBD3;
 border-radius: 16px;
 padding: 24px;
 margin-bottom: 16px;
`;

const ResultTitle = styled.h3`
 font-size: 20px;
 font-weight: 600;
 color: #00BBD3;
 margin-bottom: 16px;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ResultText = styled.p`
 font-size: 16px;
 color: #666666;
 line-height: 1.6;
 margin: 0;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ResultContent = styled.div`
 max-height: ${props => props.show ? '300px' : '0'};
 overflow: hidden;
 opacity: ${props => props.show ? '1' : '0'};
 transform: translateY(${props => props.show ? '0' : '-10px'});
 transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
`;

const ButtonRow = styled.div`
 display: flex;
 gap: 16px;
 margin-top: 40px;
`;

const BackButton = styled.button`
 background-color: white;
 color: #00BBD3;
 border: 2px solid #00BBD3;
 border-radius: 30px;
 padding: 18px 32px;
 font-size: 18px;
 font-weight: bold;
 cursor: pointer;
 transition: all 0.3s ease;
 flex: 1;
 font-family: 'Noto Sans Thai', sans-serif !important;
 box-shadow: 0 9px 14px 0 rgba(0, 187, 211, 0.08);

 &:hover {
   background-color: #00BBD3;
   color: white;
 }

 &:active {
   background-color: #009bb3;
 }
`;

const NextButton = styled.button`
 background-color: #00BBD3;
 color: white;
 border: none;
 border-radius: 30px;
 padding: 18px 32px;
 font-size: 18px;
 font-weight: bold;
 cursor: pointer;
 transition: all 0.3s ease;
 flex: 1;
 font-family: 'Noto Sans Thai', sans-serif !important;
 box-shadow: 0 9px 14px 0 rgba(0, 187, 211, 0.08);

 &:hover {
   background-color: #009bb3;
 }

 &:active {
   background-color: #008aa0;
 }
`;

const DisclaimerSection = styled.div`
 background-color: white;
 border-radius: 16px;
 padding: 24px;
 margin-bottom: 32px;
`;

const DisclaimerTitle = styled.h3`
 font-size: 18px;
 font-weight: bold;
 color: #00BBD3;
 margin-bottom: 16px;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const DisclaimerText = styled.p`
 font-size: 14px;
 color: #666;
 line-height: 1.6;
 margin-bottom: 16px;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
 
 &:last-child {
   margin-bottom: 0;
 }
`;

const Divider = styled.hr`
 border: none;
 height: 1px;
 background-color: #e1e5e9;
 margin: 40px 0;
 opacity: 0.5;
`;

const KidneyRiskSection = styled.div`
 margin-bottom: 32px;
`;

const KidneyRiskTitle = styled.h2`
 font-size: 22px;
 font-weight: 600;
 color: #00BBD3;
 margin-bottom: 8px;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const KidneyRiskSubtitle = styled.p`
 font-size: 18px;
 color: #00BBD3;
 margin-bottom: 24px;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const PrivacySection = styled.div`
 margin: 40px 0 32px 0;
 display: flex;
 align-items: flex-start;
 gap: 12px;
`;

const PrivacyCheckbox = styled.input.attrs({ type: 'checkbox' })`
 width: 20px;
 height: 20px;
 border: 2px solid #00BBD3;
 border-radius: 4px;
 background-color: white;
 cursor: pointer;
 flex-shrink: 0;
 margin-top: 2px;
 appearance: none;
 
 &:checked {
   background-color: #00BBD3;
   background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m13.854 3.646-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 9.293l6.646-6.647a.5.5 0 0 1 .708.708z'/%3e%3c/svg%3e");
   background-size: 12px;
   background-position: center;
   background-repeat: no-repeat;
 }
`;

const PrivacyLabel = styled.label`
 font-size: 16px;
 color: #666;
 line-height: 1.4;
 cursor: pointer;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const PrivacyLink = styled.span`
 color: #00BBD3;
 text-decoration: underline;
 cursor: pointer;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
 
 &:hover {
   color: #009bb3;
 }
`;

const RegisterStep3 = () => {
 const navigate = useNavigate();
 const location = useLocation();
 const previousData = location.state || {};

 const [bloodPressure, setBloodPressure] = useState('');
 const [showResult, setShowResult] = useState(false);
 const [isPrivacyAccepted, setIsPrivacyAccepted] = useState(false);

 const mockUserData = {
   age: '45',
   gender: 'ชาย',
   smoking: 'สูบ',
   diabetes: 'เป็นโรคเบาหวานชนิดที่ 2'
 };

 const handleCheckResult = () => {
   if (!bloodPressure) {
     alert('กรุณากรอกความดันโลหิตตัวบน');
     return;
   }

   if (bloodPressure !== '156') {
     alert('กรุณากรอกข้อมูลที่ถูกต้อง (156)');
     return;
   }

   setShowResult(true);
 };

 const handleBack = () => {
   navigate('/register/step2');
 };

 const handleNext = () => {
   if (!showResult) {
     alert('กรุณาทำการประเมินก่อน');
     return;
   }

   if (!isPrivacyAccepted) {
     alert('กรุณาอ่านและยอมรับ ประกาศนโยบายความเป็นส่วนตัว');
     return;
   }

   navigate('/welcome', { 
     state: { 
       ...previousData, 
       step3Data: { bloodPressure, assessmentComplete: true, privacyAccepted: true } 
     } 
   });
 };

 return (
   <RegisterContainer>
     <Header>
       <Logo src="./logo.png" alt="MFU Logo" />
       <HeaderTitle>MFU Wellness Center</HeaderTitle>
     </Header>

     <StepIndicator>
       <StepCircle active>1</StepCircle>
       <StepLine active />
       <StepCircle active>2</StepCircle>
       <StepLine active />
       <StepCircle active>3</StepCircle>
     </StepIndicator>

     <Content>
       <SectionTitle>ประเมินความเสี่ยงหลอดเลือดสมอง</SectionTitle>
       <SectionSubtitle>Thai CV risk score แบบไม่ใช้ผลเลือด</SectionSubtitle>
       
       <InfoGrid>
         <InfoRow>
           <InfoLabel>อายุ</InfoLabel>
           <InfoValue>{mockUserData.age} ปี</InfoValue>
         </InfoRow>
         <InfoRow>
           <InfoLabel>เพศ</InfoLabel>
           <InfoValue>{mockUserData.gender}</InfoValue>
         </InfoRow>
         <InfoRow>
           <InfoLabel>สูบบุหรี่อยู่</InfoLabel>
           <InfoValue>{mockUserData.smoking}</InfoValue>
         </InfoRow>
         <InfoRow>
           <InfoLabel>เป็นโรคเบาหวาน</InfoLabel>
           <InfoValue>{mockUserData.diabetes}</InfoValue>
         </InfoRow>
       </InfoGrid>

       <InputSection>
         <InputLabel>ความดันโลหิตตัวบน วัดครั้งล่าสุด</InputLabel>
         <InputRow>
           <PressureInput
             type="number"
             value={bloodPressure}
             onChange={(e) => setBloodPressure(e.target.value)}
           />
           <UnitLabel>mmHg</UnitLabel>
           <CheckButton onClick={handleCheckResult}>
             ดูผล
           </CheckButton>
         </InputRow>
       </InputSection>

       <ResultSection>
         <ResultCard>
           <ResultTitle>{showResult ? 'ผลการประเมิน' : 'ผลการประเมิน'}</ResultTitle>
           {!showResult && (
             <ResultText>
               รายละเอียดการประเมิน
             </ResultText>
           )}
           <ResultContent show={showResult}>
             <ResultText>
               ท่านมีความเสี่ยง โปรดสอบถามผู้เชี่ยวชาญด้านการดูแลสุขภาพของคุณว่าคุณ
               สามารถลดความเสี่ยงได้อย่างไร โรคหลอดเลือดสมองสามารถป้องกัน รักษา 
               และเอาชนะได้เป็นส่วนใหญ่ ถ้าได้รับการดูแลและตรวจสอบอย่างสม่ำเสมอจากผู้
               เชี่ยวชาญ
             </ResultText>
           </ResultContent>
         </ResultCard>

         <ResultCard>
           <ResultTitle>{showResult ? 'ข้อแนะนำเบื้องต้น' : 'ข้อแนะนำเบื้องต้น'}</ResultTitle>
           {!showResult && (
             <ResultText>
               คำแนะนำสำหรับคุณ
             </ResultText>
           )}
           <ResultContent show={showResult}>
             <ResultText>
               เพื่อป้องกันการเกิดโรคหลอดเลือดในอนาคตควรออกกำลังกายอย่างสม่ำเสมอ 
               รับประทานผักผลไม้เป็นประจำลดน้ำหนักให้อยู่ในเกณฑ์ปกติ และตรวจสุขภาพประจำปี
             </ResultText>
           </ResultContent>
         </ResultCard>
       </ResultSection>

       <DisclaimerSection>
         <DisclaimerTitle>หมายเหตุ (Disclaimer) การใช้เครื่องมือประเมินความเสี่ยงโรคหัวใจและหลอดเลือด</DisclaimerTitle>
         <DisclaimerText>
           • ผลลัพธ์ที่ได้เป็นการประเมินความเสี่ยงต่อการเจ็บป่วยหรือเสียชีวิตจากโรคเส้นเลือดหัวใจตีบตันและโรคเส้นเลือดสมองตีบตันในระยะเวลา 10 ปีข้างหน้า
         </DisclaimerText>
         <DisclaimerText>
           • ผลการประเมินและคำแนะนำที่ได้รับจากโปรแกรมนี้ไม่สามารถใช้แทนการตัดสินใจของแพทย์ได้ การตรวจรักษาเพิ่มเติมหรือการให้ยารักษาขึ้นอยู่กับดุลยพินิจของแพทย์และการปรึกษากันระหว่างแพทย์และตัวท่าน
         </DisclaimerText>
         <DisclaimerText>
           • ผลการประเมินนี้ห้ามนำไปใช้อ้างอิงในการค้า เช่น การทำประกันชีวิต และไม่สามารถใช้กับผู้ป่วยโรคลิ้นหัวใจหรือโรคหัวใจเต้นผิดจังหวะได้
         </DisclaimerText>
       </DisclaimerSection>

       <Divider />

       <KidneyRiskSection>
         <KidneyRiskTitle>ประเมินความเสี่ยงโรคไต</KidneyRiskTitle>
         <KidneyRiskSubtitle>Thai CKD risk score แบบไม่ใช้ผลเลือด</KidneyRiskSubtitle>
         
         <ResultSection>
           <ResultCard>
             <ResultTitle>{showResult ? 'ผลการประเมิน' : 'ผลการประเมิน'}</ResultTitle>
             {!showResult && (
               <ResultText>
                 รายละเอียดการประเมิน
               </ResultText>
             )}
             <ResultContent show={showResult}>
               <ResultText>
                 ท่านมีความเสี่ยง ปานกลาง ต่อการเกิดโรคไตในระยะเวลา 10 ปี (5%)
               </ResultText>
             </ResultContent>
           </ResultCard>

           <ResultCard>
             <ResultTitle>{showResult ? 'ข้อแนะนำเบื้องต้น' : 'ข้อแนะนำเบื้องต้น'}</ResultTitle>
             {!showResult && (
               <ResultText>
                 คำแนะนำสำหรับคุณ
               </ResultText>
             )}
             <ResultContent show={showResult}>
               <ResultText>
                 เพื่อป้องกันการเกิดโรคไตในอนาคต ควรออกกำลังกายอย่างสม่ำเสมอ ดื่มน้ำให้เพียงพอ ลดกินเค็ม ลดน้ำหนักให้อยู่ในเกณฑ์ปกติ
               </ResultText>
             </ResultContent>
           </ResultCard>
         </ResultSection>

         <DisclaimerSection>
           <DisclaimerTitle>หมายเหตุ (Disclaimer) ของการใช้เครื่องมือประเมินความเสี่ยงการเกิดโรคไตเรื้อรัง (Thai CKD Risk Score)</DisclaimerTitle>
           <DisclaimerText>
             • ผลลัพธ์ที่ได้เป็นการประเมินความน่าจะเป็นของโอกาสเกิดโรคไต (อัตราการกรองของไต &lt; 60 มิลลิลิตรนาที/1.73 ตร.ม.) ในระยะเวลา 10 ปีข้างหน้า โดยค่าที่แสดงเป็นการประมาณเบื้องต้นที่อ้างอิงจาก Saranburut et al. BMC Nephrology (2017) 18:240.
           </DisclaimerText>
           <DisclaimerText>
             • ผลการประเมินและคำแนะนำที่ได้รับจากโปรแกรมนี้ไม่สามารถใช้แทนการตัดสินใจของแพทย์ได้การตรวจรักษาเพิ่มเติมหรือการให้ยารักษาขึ้นอยู่กับดุลยพินิจของแพทย์และการปรึกษากันโดยตรงระหว่างแพทย์และตัวท่าน
           </DisclaimerText>
           <DisclaimerText>
             • ผลการประเมินนี้ห้ามนำไปใช้อ้างอิงในการค้า ธุรกิจหรือการทำธุรกรรมเพื่อหวังผลประโยชน์สิ่งใดสิ่งหนึ่ง อาทิเช่น การทำประกันชีวิตและไม่สามารถนำไปใช้กับผู้ป่วยที่ทราบว่าเป็นโรคไตอยู่เดิมได้
           </DisclaimerText>
         </DisclaimerSection>
       </KidneyRiskSection>

       <PrivacySection>
         <PrivacyCheckbox
           id="privacy-policy"
           checked={isPrivacyAccepted}
           onChange={(e) => setIsPrivacyAccepted(e.target.checked)}
         />
         <PrivacyLabel htmlFor="privacy-policy">
           คุณได้อ่านและยอมรับ ประกาศนโยบายความเป็นส่วนตัว{' '}
           <PrivacyLink onClick={() => window.open('https://dietz.asia/terms.html', '_blank')}>
             (Privacy Notice)
           </PrivacyLink>
         </PrivacyLabel>
       </PrivacySection>

       <ButtonRow>
         <BackButton onClick={handleBack}>
           ก่อนหน้า
         </BackButton>
         <NextButton onClick={handleNext}>
           ถัดไป
         </NextButton>
       </ButtonRow>
     </Content>
   </RegisterContainer>
 );
};

export default RegisterStep3;